import React, { useCallback, useEffect, useState } from 'react';

import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import PrimaryTabbedComponent from '../../shared/components/layout/PrimaryTabbedComponent';
import ProjectExpenditures from './ProjectExpenditures';
import GST from './GST';
import NoDataFound from '../components/layout/NoDataFound';
import PendingBills from './PendingBills';
import AccountsPaidBills from './AccountsPaidBills';
import { AccountsReportToolbarProvider, useAccountsReportToolbar } from '../contexts/AccountsReportToolbarContext';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import { useSmartBack } from '../../shared/navigation';

const tabbedComponentMetaData = {
  tabs: [
    'Project Expenditures',
    'Sales GST',
    'Paid Bills',
    'Pending Bills'
  ]
};

function AccountsReportMain() {
  const userId = Cookies.get('userId');
  const [primaryTab, setPrimaryTab] = useState('Project Expenditures');
  const { collapsed } = useSidebar();
  const { endAction } = useAccountsReportToolbar();
  const { onBack } = useSmartBack({ fallback: '/builder/dashboard' });

  useEffect(() => {
    mixpanel.track('Accounts Report Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    const savedPrimaryTab = localStorage.getItem('primaryTab');
    // The GST tab was renamed Sales GST; a tab saved under the old name still opens.
    if (savedPrimaryTab) setPrimaryTab(savedPrimaryTab === 'GST' ? 'Sales GST' : savedPrimaryTab);
  }, []);

  useEffect(() => {
    return () => {
      localStorage.removeItem('primaryTab');
    };
  }, []);

  const handleChangePrimaryTab = useCallback((tabName) => {
    setPrimaryTab(tabName);
    localStorage.setItem('primaryTab', tabName);
  }, []);

  return (
    <>
      <div className="z-50 ">
        <Header data={{ name: 'Accounts Reports' }} backArrow={true} onBack={onBack} />
      </div>
      <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
        <div className="w-full z-10 bg-white">
          <PrimaryTabbedComponent
            data={tabbedComponentMetaData}
            activePrimary={primaryTab}
            onChangePrimaryTab={(tab) => handleChangePrimaryTab(tab)}
            endAction={endAction}
          />
        </div>

        {primaryTab === 'Project Expenditures' && (
          <div className="w-full h-full">
            <ProjectExpenditures key={'ProjectExpenditures'} />
          </div>
        )}

        {primaryTab === 'Sales GST' && (
          <div className="w-full h-full">
            <GST key={'GST'} />
          </div>
        )}

        {primaryTab === 'RERA' && (
          <div className="w-full h-full">
            <NoDataFound />
          </div>
        )}

        {primaryTab === 'Advance Tax' && (
          <div className="w-full h-full">
            <NoDataFound />
          </div>
        )}

        {primaryTab === 'Paid Bills' && (
          <div className="w-full h-full">
            <AccountsPaidBills key={'AccountsPaidBills'} />
          </div>
        )}

        {primaryTab === 'Pending Bills' && (
          <div className="w-full h-full">
            <PendingBills key={'PendingBills'} />
          </div>
        )}

        {primaryTab === 'Advances' && (
          <div className="w-full h-full">
            <NoDataFound />
          </div>
        )}

        {primaryTab === 'Individual Ledgers' && (
          <div className="w-full h-full">
            <NoDataFound />
          </div>
        )}
      </div>
    </>
  );
}

const AccountsReport = () => {
  return (
    <>
      <Layout>
        <AccountsReportToolbarProvider>
          <AccountsReportMain />
        </AccountsReportToolbarProvider>
      </Layout>
    </>
  );
};

export default AccountsReport;
